export default {
  // LOADERS: state => {
  //   return Object.values(state.loaders);
  // },
};
